import { createAsyncThunk } from "@reduxjs/toolkit";

const GetCaseHistory = createAsyncThunk(
    "audit-logs/GetCaseHistory",
    async (payload?: any) => {
        try {
            // const data = await auditlogs.getAuditLogs(payload)
            // return data;
        } catch (err) {
            console.log("error");
        }
    }
);

export { GetCaseHistory };